module.exports = __webpack_public_path__ + "static/media/card_location.7cb34569.png";